// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1___75f434507646c03fed0","cls2":"CreateSocialItemModal-cls2___bfc4b2c06c4f7c52378 CreateSocialItemModal-cls1___75f434507646c03fed0"};